import { type ReactElement, type SVGProps } from 'react';

export const FloorPlanIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H13V13H3V3ZM4 4V12H14V20H20V4H4Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.9867 9.00341V12.648H12.9867V9.00341H13.9867Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.9867 3.49554V7.00006H12.9867V3.49554H13.9867Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 13H13.5288V12H16V13Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M20.5055 13H18V12H20.5055V13Z" fill="currentColor" />
    </svg>
  );
};
